import { useTranslation } from 'react-i18next';

import { constants } from '@hero/configs';
import { RECOGNITION_STATUSES } from '@hero/constants';

function useRecognitionTableFilterOptions() {
  const { t } = useTranslation();

  return [
    { label: t('live'), value: RECOGNITION_STATUSES.live },
    { label: t('readyToSend'), value: RECOGNITION_STATUSES.readyToSend },
    { label: t('draft'), value: RECOGNITION_STATUSES.draft },
    { label: t('ended'), value: RECOGNITION_STATUSES.expired },
    { label: t('archived'), value: RECOGNITION_STATUSES.archived },
    { label: t('approvalPending'), value: RECOGNITION_STATUSES.pending_approval },
    { label: t('processingError'), value: RECOGNITION_STATUSES.error_on_start },
    { label: t('processing'), value: RECOGNITION_STATUSES.starting }
  ].filter(option => {
    return constants?.recognition?.table?.statuses.includes(option.value);
  });
}

export { useRecognitionTableFilterOptions };
